import {GridMediaItem} from '@Components/base-grid/components/grid-media-item';
import type {ReactElement} from 'react';
import React, {useState} from 'react';
import styles from '@Components/base-grid/components/grid-sticker-item/grid-sticker-item.module.scss';
import type {GridStillStickerItemProps} from '@Components/base-grid/components/grid-still-sticker-item/grid-still-sticker-item.types';
export function GridStillStickerItem({...props}: GridStillStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
          }}
          src={props.thumbSrc}
          className={`radius-12 ${styles.thumb}`}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
